import React from 'react';
import BaseAlert, { BaseAlertProps } from 'libs/core-components/Alert/BaseAlert';
import colors from 'settings/colors';
import styled from 'styled-components';
import ErrorIcon from 'common/Icon/semantic/ErrorIcon';

export const StyledErrorAlert = styled(BaseAlert)`
    background: ${colors.semantic.error};
    color: white;
`;

type ErrorAlertProps = Omit<BaseAlertProps, 'icon'>;

export default function ErrorAlert({ children, ...rest }: ErrorAlertProps) {
    return (
        <StyledErrorAlert icon={<ErrorIcon />} {...rest}>
            {children}
        </StyledErrorAlert>
    );
}
